import awsdk from 'awsdk';
import { errors } from '../constants';

export default class AwsdkError extends Error {
  readonly method: string;
  readonly errorCode: string;
  readonly reason: string;

  static catchAwsdkError(err: Error | awsdk.AWSDKError) {
    let error = '';

    if (typeof err === 'string') {
      error = err;
    }

    if (err instanceof awsdk.AWSDKError) {
      switch (err.errorCode) {
        case awsdk.AWSDKErrorCode.internalError:
          error = errors.INTERNAL_ERROR;
          break;
        case awsdk.AWSDKErrorCode.illegalArgument:
          error = errors.INCORRECT_PARAMETERS;
          break;
        case awsdk.AWSDKErrorCode.consumerNotAuthenticated:
          error = errors.NOT_AUTHENTICATED;
          break;
        case awsdk.AWSDKErrorCode.validationDependentMatchFound:
          error = errors.DEPENDENT_EXISTS;
          break;
        case awsdk.AWSDKErrorCode.authenticationSessionExpired:
          error = errors.SESSION_EXPIRED;
          break;
        case awsdk.AWSDKErrorCode.validationRequiredParameterMissing:
          error = errors.MISSING_PARAMETERS;
          break;
        case awsdk.AWSDKErrorCode.authenticationAccessDenied:
          error = errors.INCORRECT_CREDENTIALS;
          break;
        case awsdk.AWSDKErrorCode.versionIncompatible:
          error = errors.VERSION;
          break;
        case awsdk.AWSDKErrorCode.providerNotFound:
          error = errors.PROVIDER_NOT_FOUND;
          break;
        case awsdk.AWSDKErrorCode.providerNotLicensedForConsumerLocation:
          error = errors.PROVIDER_LOCATION;
          break;
        case awsdk.AWSDKErrorCode.providerVideoNotEnabled:
          error = errors.PROVIDER_VIDEO;
          break;
        case awsdk.AWSDKErrorCode.consumerAlreadyInVisit:
          error = errors.CONSUMER_IN_VISIT;
          break;
        case awsdk.AWSDKErrorCode.healthPlanIsFeedControlled:
          error = errors.CONSUMER_FEED;
          break;
        case awsdk.AWSDKErrorCode.noPaymentInformationFound:
          error = errors.NO_PAYMENT;
          break;
        case awsdk.AWSDKErrorCode.invalidCouponError:
          error = errors.INVALID_COUPON;
          break;
        case awsdk.AWSDKErrorCode.creditCardDeclinedError:
        case awsdk.AWSDKErrorCode.creditCardInvalidCVV:
        case awsdk.AWSDKErrorCode.creditCardInvalidZipCode:
        case awsdk.AWSDKErrorCode.creditCardValidationError:
          error = errors.PAYMENT_ERROR;
          break;
        case awsdk.AWSDKErrorCode.invalidServiceKeyError:
          error = errors.INVALID_SERVICE_KEY;
          break;
        case awsdk.AWSDKErrorCode.visitSummaryNotSentError:
          error = errors.VISIT_SUMMARY_ERROR;
          break;
        case awsdk.AWSDKErrorCode.ratingNotSubmittedError:
          error = errors.RATING_ERROR;
          break;
        case awsdk.AWSDKErrorCode.providerNotAvailable:
          error = errors.PROVIDER_NOT_AVAILABLE;
          break;
        case awsdk.AWSDKErrorCode.privacyPolicyDisclaimerMissing:
          error = errors.PRIVACY_DISCLAIMER_MISSING;
          break;
        case awsdk.AWSDKErrorCode.attachmentSizeTooLarge:
          error = errors.ATTACHMENT_SIZE;
          break;
        case awsdk.AWSDKErrorCode.unsupportedMimeType:
          error = errors.MIME_TYPE;
          break;
        case awsdk.AWSDKErrorCode.medicationSearchTextTooShort:
          error = errors.MEDICATION_SEARCH_TEXT_TOO_SHORT;
          break;
        default:
          error = errors.BASE;
      }
    }

    return error;
  }
  constructor(method: string, err: Error | awsdk.AWSDKError | string) {
    super();
    const errorCode = AwsdkError.catchAwsdkError(err);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AwsdkError);
    }
    this.name = 'AwsdkError';
    this.method = method;
    this.errorCode = errorCode;
    this.reason = typeof err === 'string' ? err : err.message;
  }
}
